import React, { useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import image16 from "../image/company.jpeg";

function ContactUs() {
  const serviceID = "service_eo5xzzf";
  const templateID = "template_htxc4ti";
  const userID = "r_R1sDNYxS2eBrolP";

  const [loading, setLoading] = useState(false);
  const initialFormState = {
    from_name: "",
    from_lastname: "",
    subject: "",
    contactNumber: "",
    reply_to: "",
    message: "",
  };

  const [data, setData] = useState(initialFormState);

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm(serviceID, templateID, e.target, userID)
      .then((response) => {
        console.log("Email sent successfully!", response.status, response.text);
        alert("Thank you! Your message has been sent successfully.");
        setData(initialFormState);
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        alert("Failed to send message. Please try again or call us directly.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openMap = () => {
    const locationName = "Polo PVC Pvt Ltd";
    const mapURL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationName)}`;
    const newWindow = window.open(mapURL, '_blank');
    if (newWindow) newWindow.focus();
  };

  return (
    <div className="w-full bg-slate-50/50 font-sans overflow-hidden">

      {/* Hero Section */}
      <div className="relative w-full bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 pt-20 pb-28 md:pt-24 md:pb-36 lg:pt-28 lg:pb-40 px-6 overflow-hidden">

        {/* Ambient Radial Glow Effect */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center text-white space-y-4 relative z-10">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-2 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-wider text-orange-50">Support & Inquiries</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight drop-shadow-md">
            Get in Touch
          </h1>
          <p className="text-sm sm:text-base md:text-lg font-normal leading-relaxed text-orange-50 opacity-95 max-w-2xl mx-auto">
            We are here to assist you. Whether you have product queries, require technical specifications, or need commercial quotes, our team is ready to respond.
          </p>
        </div>

        {/* Clean Solid White Curved SVG Divider */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-[0] z-10">
          <svg
            className="relative block w-full h-[60px] md:h-[100px]"
            viewBox="0 0 1920 120"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,120 C640,30 1280,30 1920,120 L1920,120 L0,120 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>

      {/* Breadcrumb Navigation Bar */}
      <div className="bg-white py-3.5 px-6 sm:px-12 border-b border-slate-100 relative z-20">
        <div className="max-w-7xl mx-auto flex items-center space-x-2 text-xs sm:text-sm font-medium text-slate-500">
          <Link to="/" className="text-orange-600 hover:text-orange-700 font-semibold transition-colors">Home</Link>
          <span className="text-slate-300 font-light">&gt;</span>
          <span className="text-slate-800">Contact Us</span>
        </div>
      </div>

      {/* Main Office Quick Contacts Grid */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-12 space-y-12">
          <div className="text-center space-y-2">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700">
              Communication Channels
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
              Corporate Office Contacts
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Call Us Card */}
            <div className="p-8 bg-white border border-slate-200/80 shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-orange-500/10 rounded-3xl transition-all hover:-translate-y-1 flex flex-col items-center text-center space-y-4">
              <div className="p-4 bg-orange-50 text-orange-600 rounded-2xl border border-orange-100 shadow-sm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-extrabold text-slate-900">Call Us Directly</h3>
                <p className="text-xs sm:text-sm text-slate-500 mt-1">Mon - Sat: 10:00 AM to 6:00 PM IST</p>
              </div>
              <div className="flex flex-col items-center space-y-2 pt-2">
                <a href="tel:+918759893275" className="text-lg sm:text-xl font-black text-orange-600 hover:text-orange-700 transition-colors">
                  +91 87598 93275
                </a>
                <a href="tel:+918759089771" className="text-lg sm:text-xl font-black text-orange-600 hover:text-orange-700 transition-colors">
                  +91 87590 89771
                </a>
              </div>
            </div>

            {/* Email Us Card */}
            <div className="p-8 bg-white border border-slate-200/80 shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-orange-500/10 rounded-3xl transition-all hover:-translate-y-1 flex flex-col items-center text-center space-y-4">
              <div className="p-4 bg-orange-50 text-orange-600 rounded-2xl border border-orange-100 shadow-sm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-extrabold text-slate-900">Email Inquiry</h3>
                <p className="text-xs sm:text-sm text-slate-500 mt-1">For sales, institutional orders, or support</p>
              </div>
              <div className="pt-2">
                <a href="mailto:sales@polopvc.com" className="text-lg sm:text-xl font-black text-orange-600 hover:text-orange-700 transition-colors">
                  sales@polopvc.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Address & Interactive Map Block */}
      <section className="py-8 bg-white px-6">
        <div className="max-w-4xl mx-auto bg-slate-900 rounded-3xl shadow-xl border border-slate-800 overflow-hidden flex flex-col md:flex-row relative">
          <div className="w-full md:w-1/2">
            <img className="w-full h-full object-cover min-h-[260px] md:min-h-full" src={image16} alt="Polo PVC Headquarters" />
          </div>
          <div className="w-full md:w-1/2 p-8 lg:p-10 flex flex-col justify-between text-white space-y-6">
            <div className="space-y-3">
              <span className="text-xs font-bold uppercase tracking-wider text-orange-400">Headquarters</span>
              <h4 className="text-2xl font-black tracking-tight">Registered Office</h4>
              <p className="text-base font-bold text-slate-100">Polo PVC Pvt. Ltd.</p>
              <p className="text-xs sm:text-sm text-slate-300 leading-relaxed font-normal">
                Palitpur Road, Dewandighi,<br />
                P.O. Mirzapur, Burdwan - 713102<br />
                West Bengal, India
              </p>
              <p className="text-xs sm:text-sm font-semibold text-slate-200">Phone: +91 87598 93275</p>
            </div>

            <button
              onClick={openMap}
              className="flex items-center justify-center space-x-2 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 hover:opacity-95 text-white py-3.5 px-6 rounded-xl font-bold shadow-lg shadow-orange-500/20 transition-all w-full md:w-auto self-start text-xs sm:text-sm cursor-pointer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 fill-current" viewBox="0 0 36.767 48.001">
                <path d="M23.143 37.881c4.178-6.076 9.957-15.809 9.957-23.164a14.718 14.718 0 0 0-29.435 0c0 7.357 5.783 17.094 9.961 23.168C6.3 38.391 0 40.074 0 42.858 0 46.235 9.248 48 18.383 48s18.383-1.766 18.384-5.143c0-2.782-6.293-4.47-13.624-4.976zM5.121 14.717a13.264 13.264 0 0 1 26.527 0c0 9.492-10.665 23.852-13.264 27.209-2.598-3.357-13.263-17.713-13.263-27.209zm13.262 31.829c-10.334 0-16.929-2.184-16.929-3.688 0-1.309 5.03-3.123 13.155-3.57a91.912 91.912 0 0 0 3.209 4.273.729.729 0 0 0 1.129 0 93.58 93.58 0 0 0 3.213-4.277c8.125.447 13.151 2.266 13.151 3.574.002 1.504-6.593 3.688-16.928 3.688z"/>
                <path d="M26.383 14.848a8 8 0 1 0-8 8 8.009 8.009 0 0 0 8-8zm-14.545 0a6.546 6.546 0 1 1 6.545 6.545 6.555 6.555 0 0 1-6.545-6.545z"/>
              </svg>
              <span>Locate on Google Maps</span>
            </button>
          </div>
        </div>
      </section>

      {/* Interactive Form Section */}
      <section className="py-16 md:py-24 bg-slate-50/50 relative">
        <div className="max-w-2xl mx-auto px-6 relative z-10">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-200/80 space-y-8">
            <div>
              <span className="text-xs font-bold uppercase tracking-wider text-orange-600 block mb-1">Send a Message</span>
              <h2 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">Submit Your Inquiry</h2>
              <p className="text-xs sm:text-sm text-slate-500 mt-1">Fill in the fields below and our sales engineering team will reach out to you promptly.</p>
            </div>

            <form onSubmit={sendEmail} className="space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <label className="font-semibold text-xs text-slate-700 mb-1.5">First Name *</label>
                  <input
                    type="text"
                    name="from_name"
                    required
                    value={data.from_name}
                    onChange={onChangeHandler}
                    placeholder="John"
                    className="w-full border border-slate-200 rounded-xl h-11 px-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all bg-slate-50/30"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-xs text-slate-700 mb-1.5">Last Name *</label>
                  <input
                    type="text"
                    name="from_lastname"
                    required
                    value={data.from_lastname}
                    onChange={onChangeHandler}
                    placeholder="Doe"
                    className="w-full border border-slate-200 rounded-xl h-11 px-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all bg-slate-50/30"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <label className="font-semibold text-xs text-slate-700 mb-1.5">Subject *</label>
                  <input
                    type="text"
                    name="subject"
                    required
                    value={data.subject}
                    onChange={onChangeHandler}
                    placeholder="Product Specifications / Quote"
                    className="w-full border border-slate-200 rounded-xl h-11 px-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all bg-slate-50/30"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold text-xs text-slate-700 mb-1.5">Contact Number *</label>
                  <input
                    type="tel"
                    name="contactNumber"
                    required
                    value={data.contactNumber}
                    onChange={onChangeHandler}
                    placeholder="+91 98765 43210"
                    className="w-full border border-slate-200 rounded-xl h-11 px-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all bg-slate-50/30"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <label className="font-semibold text-xs text-slate-700 mb-1.5">Email Address *</label>
                <input
                  type="email"
                  name="reply_to"
                  required
                  value={data.reply_to}
                  onChange={onChangeHandler}
                  placeholder="example@yourdomain.com"
                  className="w-full border border-slate-200 rounded-xl h-11 px-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all bg-slate-50/30"
                />
              </div>

              <div className="flex flex-col">
                <label className="font-semibold text-xs text-slate-700 mb-1.5">Description / Message *</label>
                <textarea
                  name="message"
                  required
                  value={data.message}
                  onChange={onChangeHandler}
                  rows="4"
                  placeholder="Tell us about your project requirements..."
                  className="w-full border border-slate-200 rounded-xl p-4 text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all resize-none bg-slate-50/30"
                />
              </div>

              {loading && (
                <p className="text-xs text-orange-600 animate-pulse font-medium">Sending email, please wait...</p>
              )}

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full sm:w-auto px-8 py-3.5 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 hover:opacity-95 text-white font-bold rounded-xl shadow-lg shadow-orange-500/20 transition-all text-xs sm:text-sm cursor-pointer"
                >
                  Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

    </div>
  );
}

export default ContactUs;